export type Point = { x: number; y: number }

/**
 * getDistanceOfPointFromRectangle - gets the distance of a point from a rectangle
 * Based off of https://stackoverflow.com/questions/5254838/calculating-distance-between-a-point-and-a-rectangular-box-nearest-point
 *
 * @param {Point} point - the point to check the distance to
 * @param {DOMRect} rect - the rectangle to check the distance from
 *
 * @return number - the distance (pixel) between the rectangle and the point. Will be 0 if the point is in the rectangle
 */
export function getDistanceOfPointFromRectangle(
	point: Point,
	rect: DOMRect
): number {
	const dx = Math.max(rect.left - point.x, 0, point.x - rect.right)
	const dy = Math.max(rect.top - point.y, 0, point.y - rect.bottom)
	return Math.sqrt(dx * dx + dy * dy)
}
